export default "__VITE_ASSET__BzJJv0Ir__"